export default {
    infoList:[ 
        {
            title:'发文趋势分析',
            type:'1',
            url:require('../../assets/images/bibliometric/line-icon.png'),
            text:'通过统计分析相关主题中医药期刊文献的发文量随时间变化的趋势，揭示相关主题的研究动态、学科发展及知识演进规律。'
        },
        {
            title:'作者分析',
            type:'2',
            url:require('../../assets/images/bibliometric/bar-icon.png'),
            text:'分析相关主题中医药期刊文献的核心研究者、高产作者，识别学术共同体形成规律。'
        },
        {
            title:'机构分析',
            type:'3',
            url:require('../../assets/images/bibliometric/axis-icon.png'),
            text:'分析相关主题中医药期刊文献的核心研究机构、高产机构，识别学术共同体形成规律。'
        },
        {
            title:'关键词词云图',
            type:'4',
            url:require('../../assets/images/bibliometric/word-pic.png'),
            text:'通过可视化方式呈现相关主题中医药期刊文献中的高频关键词，字体大小反映词频高低，颜色区分主题或权重，直观展示研究领域的核心议题、热点方向及新兴概念。'
        },
        {
            title:'关键词共现网络分析',
            type:'5',
            url:require('../../assets/images/bibliometric/network-pic.png'),
            text:'通过统计相关主题中医药期刊文献中关键词在同一篇论文中的共现频率，构建关键词间的关联网络，揭示研究领域的知识结构、主题关联及演化规律。'
        },
        {
            title:'关键词未来趋势分析',
            type:'6',
            url:require('../../assets/images/bibliometric/wlyc.jpg'),
            text:'通过对特定关键词在历史数据、当前表现及相关影响因素的分析，运用数据挖掘、机器学习、行业经验等方法，推断该关键词在未来一段时间内的关注度变化、发展方向等趋势的过程。'
        },
        {
            title:'关键词突变分析',
            type:'7',
            url:require('../../assets/images/bibliometric/network-jl.jpg'),
            text:'用于识别特定研究主题在学术文献中关注度的突然性、显著性增长。它通过分析关键词在时间序列上的出现频率变化，揭示学科前沿、新兴趋势或研究热点的爆发性演变。'
        }, 
        {
            title:'关键词聚类',
            type:'8',
            url:require('../../assets/images/bibliometric/gjcjl.jpg'),
            text:'将语义相关或主题相似的关键词自动分组，其核心目标是从大量无序的关键词中发现隐藏的主题结构、用户意图或内容模式。'
        },
    ],
    relationList:[
        { value:'AND', label:'与', },
        { value:'OR', label:'或', },
        { value:'NOT', label:'非', }
    ],
    queryType:[
        { value:'2', label:'模糊', },
        { value:'1', label:'精确', }, 
    ],
    searchInfoList:[ 
        {label:'题名',value:'cnTitle'},
        {label:'关键词',value:'keyWord'}, 
        {label:'作者',value:'author'},
        {label:'单位',value:'authorAffiliation'},
        {label:'分类号',value:'classNum'},
        // {label:'来源',value:'source'},
        {label:'时间',value:'year'},  
    ],
    letfNav:[
        // {
        //     navType:'authorAffiliation',
        //     tit:'机构',
        //     list:[]
        // },
        {
            
            navType:'year',
            tit:'年代',
            list:[]
        },
    ],
}